var _ = require('underscore/underscore.js');

var template = require('./SubmissionFormEpisodesItem.jinja');
require('./SubmissionFormEpisodesItem.less');

var moment = require('moment/moment');

var CommonCalendar = require('front/components/CommonCalendar/CommonCalendar');
var CommonCalendarTemplate = require('front/components/CommonCalendar/CommonCalendarRuntime.jinja');


var SubmissionFormBlock = require('./SubmissionFormBlock');

module.exports = SubmissionFormBlock.extend({

    template: template,

    events: {
        'input input': 'onInputChange',
        'click .SubmissionFormElement-delete': 'deleteItem',
        'click .SubmissionFormEpisodesItem-date': 'onCalendarClick'

    },

    initialize: function (options) {
        this.options = options || {};

        this.$('input[name="_id"]').val(app.utils.cid());

        SubmissionFormBlock.prototype.initialize.call(this, options);
    },


    onInputChange: function () {
        this.trigger('change');

        this.$('.SubmissionFormEpisodesItem-date')
            .closest('.SubmissionFormElement-inputLine')
            .removeClass('SubmissionFormElement-inputLine--error');
    },


    onCalendarClick: function (e) {
        var $date = this.$('.SubmissionFormEpisodesItem-date');

        if ($date.hasClass('SubmissionFormEpisodesItem-date--calendar-opened')) {
            return;
        }

        var $calendar = $(CommonCalendarTemplate.render({data: {}}));

        $date.append($calendar);

        $date.addClass('SubmissionFormEpisodesItem-date--calendar-opened');

        var calendar = new CommonCalendar({
            el: $calendar[0],
            date: $date.attr('data-date'),
            allowPastDates: true,
            warning: ''
        });

        calendar.show();

        calendar.on('close', function () {
            calendar.off();
            $date.removeClass('SubmissionFormEpisodesItem-date--calendar-opened');
        });

        calendar.on('select', function (date) {
            var dateFrom = moment(date).startOf('day');

            $date
                .attr('data-date', dateFrom.format('YYYY-MM-DD'))
                .removeClass('SubmissionFormEpisodesItem-date--empty')
                .find('span')
                .text(dateFrom.format('MM/DD/YY'));

            this.onInputChange();

        }.bind(this));
    },


    deleteItem: function (e) {
        this.remove();

        this.trigger('delete');
    },


    checkRequired: function () {

        var res = SubmissionFormBlock.prototype.checkRequired.call(this);

        //custom dates check
        if (res) {
            var $wrapper = this.$('.SubmissionFormEpisodesItem-date').closest('.SubmissionFormElement-inputLine');
            var isRequired = $wrapper.find('.SubmissionFormElement-inputName').hasClass('SubmissionFormElement-inputName--required');

            res = !!this.getData().date;

            if (isRequired && !res) {

                $wrapper.addClass('SubmissionFormElement-inputLine--error');

                app.animateWindowScroll($wrapper.offset().top - 380);

                this.onCalendarClick();

                return false;
            }
        } else {
            return false;
        }

        return true;
    },


    getData: function () {
        var data = {
            'title': this.$('input[name="title"]').val(),
            'date': this.$('.SubmissionFormEpisodesItem-date').attr('data-date') || null
        };

        if (this.$('input[name="id"]').val()) {
            data.id = parseInt(this.$('input[name="id"]').val(), 10);
        }

        if (this.$('input[name="_id"]').val()) {
            data._id = parseInt(this.$('input[name="_id"]').val(), 10);
        }

        return data;
    }
});





//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormEpisodesItem.js
// module id = 116
// module chunks = 0